module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_staffanstorp-aab5d3ce848af853b4bd388addf0d7db.png";